
import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";

function NoFollowMeta(props) {

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex"/>
            </Helmet>
        </>
    );
}

export default NoFollowMeta;


